import React, { useContext } from "react";
import { UserContext, UserRole } from "../Provider";
import { Outlet } from "react-router-dom";

export interface MiddlewareCompProps {
    roles: UserRole[];
    notHave?: boolean;
}

const MiddlewareByRoleComp: React.FC<MiddlewareCompProps> = ({
    roles,
    notHave = false,
    ...props
}: MiddlewareCompProps) => {
    const user = useContext(UserContext);
    const countRoles = (user && user.roles.filter((e) => roles?.includes(e)).length) ?? 0;
    const isCheck = notHave ? countRoles <= 0 : countRoles > 0;
    if (
        user && isCheck
    ) {
        return <Outlet />;
    }
    window.location.href = "/404";
    return null;
};

export default React.memo(MiddlewareByRoleComp);
